import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.oppo_user_assigned_uid &&
			modifiedModel.oppo_user_assigned_uid !== model.oppo_user_modified_uid
		) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.oppo_user_modified_uid,
						assignedTo: modifiedModel.oppo_user_assigned_uid,
						title: 'Nuova Opportunità assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.oppo_title}".`,
						url: `${window.location.origin}/opportunities/details/${model.oppo_uid}`,
						icon: 'thought-bubble-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
